// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"151":"FavSearch","290":"FavList","324":"FavDetail"}[chunkId] || chunkId) + "." + {"70":"98d7b169","151":"d2d21a34","290":"572d89ba","324":"cb2eae55","527":"4b5144ac","629":"2300ca8d","849":"8835155b"}[chunkId] + ".js";
};